import * as actionTypes from "../actions/actionTypes";

const community = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.COMMUNITY:
      return { ...state, communityId: action.payload };

    default:
      return state;
  }
};

export default community;
